import { defineStore } from 'pinia'

interface dashboardConfig {
  [key: string]: any
}

interface device {
  [key: string]: any
}

interface IDevice {
  irebox: string
  inverter_type: string
  irebox_alias?: string
  irebox_name?: string
  irebox_notes?: string
  scheduler: boolean
  web_irebox_config?: any
}

export const useGlobalStore = defineStore('global', {
  state: () => {
    return {
      isSidebarMinimized: false,
      ireboxUUID: localStorage.getItem('ireboxUUID') || '',
      inverterType: localStorage.getItem('inverterType') || '',
      dashboardConfig: {} as dashboardConfig,
      devices: [] as device[],
    }
  },

  actions: {
    toggleSidebar() {
      this.isSidebarMinimized = !this.isSidebarMinimized
    },

    getDevices() {
      return this.devices
    },

    setDevices(devices: any) {
      this.devices = devices
    },

    getDashboardConfig() {
      return this.dashboardConfig
    },

    setDashboardConfig(dashboardConfig: any) {
      this.dashboardConfig = dashboardConfig
    },

    getDashboardConfigComponent(componentName: string) {
      return this.dashboardConfig.widgets.includes(componentName)
    },

    getIreboxUUID() {
      return this.ireboxUUID
    },

    setIreboxUUID(ireboxUUID: string) {
      localStorage.setItem('ireboxUUID', ireboxUUID)
      this.ireboxUUID = ireboxUUID
    },

    getInverterType() {
      return this.inverterType
    },

    getInverterTypeByID(ireboxUUID: string) {
      return this.devices.find((device) => device.irebox === ireboxUUID)?.inverter_type
    },

    hasSchedulerEnabled(ireboxUUID: string) {
      return this.devices.find((device) => device.irebox === ireboxUUID)?.scheduler
    },

    setInverterType(inverterType: string) {
      localStorage.setItem('inverterType', inverterType)
      this.inverterType = inverterType
    },

    isMultipartInverter(ireboxUUID: string) {
      return this.devices.find((device) => device.irebox === ireboxUUID)?.powerflow_mapping.multipart || false
    },

    getMapping(ireboxUUID: string) {
      return this.devices.find((device) => device.irebox === ireboxUUID)?.powerflow_mapping
    },

    getDeviceByIrebox(ireboxUuid: string): IDevice | null {
      return (this.devices.find((d) => d.irebox === ireboxUuid) as IDevice | undefined) ?? null
    },

    getInverterSnByIrebox(ireboxUuid: string): string | null {
      const d: any = this.getDeviceByIrebox(ireboxUuid)
      const mi = d?.powerflow_mapping?.multipart_inverters

      if (!Array.isArray(mi) || mi.length === 0) return null

      const first = mi[0]
      // ak je to string
      if (typeof first === 'string') return first

      // ak je to objekt typu { sn: "..." } alebo podobne
      if (first && typeof first === 'object') {
        return first.sn ?? first.SN ?? first.serial_number ?? null
      }

      return null
    },

    getVendorByIrebox(ireboxUuid: string): 'sinexcel' | 'deye' | null {
      const d = this.getDeviceByIrebox(ireboxUuid)
      if (!d?.inverter_type) return null
      const s = d.inverter_type.toLowerCase()
      if (s.includes('sinexcel')) return 'sinexcel'
      if (s.includes('deye')) return 'deye'
      return null
    },

    getFaultsTargetByIrebox(ireboxUuid: string): { vendor: 'sinexcel' | 'deye'; sn: string | null } | null {
      const d: any = this.getDeviceByIrebox(ireboxUuid)
      if (!d?.inverter_type) return null

      const s = String(d.inverter_type).toLowerCase()
      const vendor = s.includes('sinexcel') ? 'sinexcel' : s.includes('deye') ? 'deye' : null
      if (!vendor) return null

      const mi = d?.powerflow_mapping?.multipart_inverters
      let sn: string | null = null
      if (Array.isArray(mi) && mi.length > 0) {
        const first = mi[0]
        sn = typeof first === 'string' ? first : (first?.sn ?? first?.SN ?? first?.serial_number ?? null)
      }

      return { vendor, sn }
    },
  },
})
